import React, { useState, useEffect } from 'react';
import { Menu } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

const CategoryModal = ({ isOpen, category, onClose, onSave }) => {
  const [form, setForm] = useState({
    name: '',
    description: '',
    icon: 'Gift',
    show_in_menu: false,
    menu_order: 0
  });

  useEffect(() => {
    if (category) {
      setForm({
        id: category.id,
        name: category.name || '',
        description: category.description || '',
        icon: category.icon || 'Gift',
        show_in_menu: category.show_in_menu || false,
        menu_order: category.menu_order || 0
      });
    } else {
      setForm({ name: '', description: '', icon: 'Gift', show_in_menu: false, menu_order: 0 });
    }
  }, [category]);

  const handleSubmit = () => {
    if (!form.name) {
      alert('Nome é obrigatório');
      return;
    }
    onSave(form);
  };

  const icons = ['Gift', 'Heart', 'FileText', 'Calendar', 'Briefcase', 'GraduationCap'];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{category ? 'Editar Categoria' : 'Nova Categoria'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Nome *</label>
            <Input 
              value={form.name}
              onChange={(e) => setForm(prev => ({ ...prev, name: e.target.value }))}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Descrição</label>
            <Textarea 
              value={form.description}
              onChange={(e) => setForm(prev => ({ ...prev, description: e.target.value }))}
              rows={2}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Ícone</label>
            <div className="flex flex-wrap gap-2">
              {icons.map(icon => (
                <button
                  key={icon}
                  onClick={() => setForm(prev => ({ ...prev, icon }))}
                  className={`px-3 py-2 rounded-lg text-sm ${form.icon === icon ? 'bg-teal-600 text-white' : 'bg-slate-100 text-slate-600'}`}
                >
                  {icon}
                </button>
              ))}
            </div>
          </div>

          {/* Show in Menu Toggle */}
          <div className="flex items-center justify-between p-4 bg-[#195C75]/10 rounded-lg border border-[#195C75]/20">
            <div>
              <label className="block text-sm font-medium text-[#195C75] flex items-center gap-2">
                <Menu className="w-4 h-4" />
                Mostrar no Menu Principal
              </label>
              <p className="text-xs text-[#195C75]/70">Ative para mostrar esta categoria na barra de navegação</p>
            </div>
            <button
              type="button"
              onClick={() => setForm(prev => ({ ...prev, show_in_menu: !prev.show_in_menu }))}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${form.show_in_menu ? 'bg-[#195C75]' : 'bg-slate-300'}`}
              data-testid="show-in-menu-toggle"
            >
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${form.show_in_menu ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>

          {/* Menu Order - Only show if show_in_menu is enabled */}
          {form.show_in_menu && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Ordem no Menu (menor = primeiro)</label>
              <Input 
                type="number"
                min="0"
                value={form.menu_order}
                onChange={(e) => setForm(prev => ({ ...prev, menu_order: parseInt(e.target.value) || 0 }))}
                className="w-24"
              />
            </div>
          )}

          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={onClose}>Cancelar</Button>
            <Button onClick={handleSubmit} className="bg-teal-600 hover:bg-teal-700 text-white">
              Salvar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryModal;
